export  default [
    {
        category: 'Front End Development',
        img: 'img/skills_symbols/monitor.svg',
        display: true,
        description: 'I specialize in designing and implementing a great UI/UX for web and mobile apps.',
        items: [
            'HTML / CSS / JavaScript',
            'Angular',
            'Vue.js',
            'React',
            'Unity / C#'
        ]
    },
    {
        category: 'Back End Development',
        img: 'img/skills_symbols/server.svg',
        display: true,
        description: 'I find the applications of these technologies intriguing.',
        items: [
            'Node.js / Express',
            'MongoDB / mongooose',
            'Redis / Bee-queue',
            'SQL',
            '.NET Core'
        ]
    },
    {
        category: 'General Programming',
        img: 'img/skills_symbols/keyboard.svg',
        display: false,
        description: 'C++ was the language I first learned to program with. Since then I have worked with other languages for a variety of applications.',
        items: [
            'C++',
            'C#',
            'Java',
            'Python',
        ]
    },
    {
        category: 'General Skills',
        img: 'img/skills_symbols/keyboard.svg',
        display: true,
        description: 'These are things I use for the architectural design and development of the apps I build.',
        items: [
            'Object Orientated Programming',
            'UML',
            'Git',
            'Agile (SCRUM) / Waterfall',
            'Unit Testing',
        ]
    },
]